import { useContext } from 'react';
import LottoAssistantStateContext from '../context/lottoAssistantStateContext';
import LottoAssistantActionsContext from '../context/lottoAssistantActionsContext';
import LottoAssistantIntentsContext from '../context/lottoAssistantIntentsContext';

export const useAssistantState = () => useContext(LottoAssistantStateContext);

export const useAssistantActions = () =>
  useContext(LottoAssistantActionsContext);

export const useAssistantIntents = () =>
  useContext(LottoAssistantIntentsContext);

const useLottoAssistantContext = () => ({
  state: useAssistantState(),
  actions: useAssistantActions(),
  intents: useAssistantIntents(),
});

export default useLottoAssistantContext;
